import React, { useEffect, useState } from "react";
import "./LiveHelpSection.scss";
import Button from "../Components/Buttons/Button";
import CategoryCard from "./Card/CategoryCard";
import { getCategoryWiseSubcategory } from "../services/getCategoryWiseSubcategory";

const LiveHelpSection = ({ setIsModelOpen, setTypeData }) => {
  const [pageData, setPageData] = useState([]);
  const fetchData = async () => {
    await getCategoryWiseSubcategory("65524e353c005ef3b51907c2")
      .then((data) => {
        setPageData(data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

   if(!pageData?.subCategory?.length){
    return null;
  }

  return (
    <div className="container">
    <div className="livesection">
      <div  className="title">Live Session Help</div>
      <div className="description">
        Instant live support for online classes and exams.
      </div>
      <div className="card-wrapper">
        <div className="row justify-content-center">
          {pageData?.subCategory?.map((item, index) => (
            <div
              key={index}
              className="col-12  col-md-6 col-lg-4 d-flex justify-content-center mb-4"
            >
              <CategoryCard details={item}   />
            </div>
          ))}
        </div>
        </div>
      <Button
        text="Get Live Session Help"
        varient="primary"
        onClick={() => {
          setTypeData({
            serviceType: "LiveSessionHelp",
            type: "livesessionHelp",
            totalSteps:3,
          });
          setIsModelOpen(true);
        }}
      ></Button>
    </div>

    </div>
  );
};

export default LiveHelpSection;
